module.exports = __webpack_public_path__ + "img/calender.188d1006.svg";